import React from "react";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "../styles/LayoutCard.css";
import { formatUrl } from "../utils/config";

const LayoutCard = ({ layout, loading = false }) => {
  if (loading) {
    return (
      <div className="col-xl-4 col-md-6">
        <div className="estate-card">
          <div className="estate-img">
            <Skeleton height={250} />
          </div>
          <div className="estate-content">
            <h4 className="estate-title">
              <Skeleton width={200} />
            </h4>
            <p className="estate-location">
              <Skeleton width={180} />
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (!layout) return null;

  return (
    <div className="col-xl-4 col-md-6">
      <div className="estate-card">
        <div className="estate-img">
          <Link to={`/layouts/${layout.id}`}>
            <img
              src={
                formatUrl(layout?.thumbnail) || "/assets/img/layout-default.jpg"
              }
              alt={layout.name}
              onError={(e) => (e.target.src = "/assets/img/default-offer.png")}
            />
          </Link>
        </div>
        <div className="card-content p-3">
          <h4 className="estate-title">
            <Link to={`/layouts/${layout.id}`}>{layout.name}</Link>
          </h4>
          <h5 className="estate-type">{layout.acquisitionType}</h5>
          <p className="estate-location">
            <i className="fas fa-map-marker-alt"></i>{" "}
            {[layout.district, layout.lga, layout.state]
              .filter(Boolean)
              .join(", ")}
          </p>
          <div className="mt-3">
            <Link
              to={`/layouts/${layout.id}`}
              state={{ layout }}
              className="th-btn"
              style={{
                backgroundColor: "var(--theme-color)",
                color: "#fff",
                display: "inline-block",
                padding: "10px 18px",
                borderRadius: "4px",
                textDecoration: "none",
              }}
            >
              View Details <i className="fas fa-arrow-right ms-1" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LayoutCard;
